import * as moment from "moment";

export class ConnectedVenuesFakeDb {
  public static venues = [
    {
      uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      client: {
        name: "Robert's Super Security Firm Pty Ltd",
        uuid: "12341234134",
      },
      venue: {
        managers: [
          {
            address: "23 Norton Plaza, Leichardt, NSW, 2040",
            email: "mike@gmail.com",
            name: "Mike Miriston",
            phone: "+61437794659",
            uuid: "6273g2y3ye23egb2e",
          },
        ],
        accreditation_requirements: [
          {
            description:
              "A valid NSW security licence is required to work at this venue.",
            name: "NSW Security Licence",
            source: "https://www.example.com/nsw-security-licence.pdf",
            template_uuid: "123456789",
            timing_requirement: "Before Shift Start",
            type: "Security",
          },
        ],
        address: {
          geo_location: {
            coordinates: [
              151.157,
              -33.884,
            ],
            type: "Point",
          },
          "google-call":
            "https://maps.googleapis.com/maps/api/place/details/json?placeid=xyz",
          "google-place-id": "ChIJN1t_tDeuEmsRUsoyG83frY4",
          street_location: "23 Norton Plaza, Leichhardt, NSW, 2040",
          timezone:"Australia/Sydney"
        },
        comment:
          "Ensure compliance with security accreditation before shift start.",
        contract_review_date: "2023-01-01",
        contract_start_date: "2019-01-01",
        contract_term: "2 Years",
        documents: [
          {
            date_added: "2022-06-15",
            date_modified: "2023-04-10",
            description: "Signed contract agreement",
            name: "Security Service Agreement",
            private: true,
            tag: "contract",
            uuid: "abc123-def456-ghi789",
          },
        ],
        executing_parties: "John Smith, CEO; Peter Holiday, Manager",
        licence_name: "Security Operations Licence",
        licence_number: "NSW-SEC-987654",
        logo: "https://www.example.com/venue-logo.png",
        name: "Norton Plaza Security",
        roles: [
          {
            credentials: [
              {
                data: '{"template_uuid":"636086a9d9dbfb0537f92125","type":"Identification","name":"Security ID","description":"Passport or Driver\'s Licence","timing_requirement":"Before commencing the Shift","source":"https://www.example.com/security-id.pdf","selected":true}',
                roles: [0],
                tags: [
                  "tag1",
                  "tag2",
                ],
                template: "1234-1234-1234",
                type: "Induction",
                uuid: "1234-1234-1234",
              },
            ],
            resource_rate_id: "d8e28207-ad9f-4620-906c-117ef0ed4938",
            description: "Responsible for maintaining security at the venue.",
            item_code: "#123-321",
            name: "Security Guard",
            rates: [
              {
                item_code: "#123 456",
                name: "Standard",
                value: 10,
              },
            ],
            uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
          },
        ],
        stations: [
          {
            name: "Main Entrance Checkpoint",
          },
        ],
        type: "Private",
        uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        sign_on_distance: 100,
        resource_rates: [
          {
            description: "Hourly rates for security personnel.",
            name: "Security Service Rates",
            rates: [
              {
                item_code: "STD001",
                name: "Standard",
                value: 15,
              },
              {
                item_code: "PREM002",
                name: "Premium",
                value: 35,
              },
              {
                item_code: "DISC003",
                name: "Discount",
                value: 45,
              },
            ],
            uuid: "d8e28207-ad9f-4620-906c-117ef0ed4938",
          },
        ],
      },
    },
    {
      uuid: "7hb17h96-8049-7894-e6if-5f296i99did9",
      client: {
        name: "Great Man",
        uuid: "98746563111",
      },
      venue: {
        managers: [
          {
            address: "789 King Street, Sydney, NSW, 2000",
            email: "manager@greatman.com.au",
            name: "David Thompson",
            phone: "+61289876543",
            uuid: "8765f4e3d2c1b0a9",
          },
        ],
        accreditation_requirements: [
          {
            description:
              "A valid NSW security licence is required to work at this venue.",
            name: "NSW Security Licence",
            source: "https://www.example.com/nsw-security-licence.pdf",
            template_uuid: "789456123",
            timing_requirement: "Before Shift Start",
            type: "Security",
          },
          {
            description:
              "NSW Liquor Licence required for venue operations.",
            name: "NSW Liquor Licence",
            source: "https://www.example.com/nsw-liquor.pdf",
            template_uuid: "321654987",
            timing_requirement: "Before Shift Start",
            type: "Liquor",
          },
        ],
        address: {
          geo_location: {
            coordinates: [
              151.2093,
              -33.8688,
            ],
            type: "Point",
          },
          "google-call":
            "https://maps.googleapis.com/maps/api/place/details/json?placeid=def456",
          "google-place-id": "ChIJ38WhZwuG1moR2RacP5hJ7HE",
          street_location: "789 King Street, Sydney, NSW, 2000",
          timezone: "Australia/Sydney"
        },
        comment:
          "Premium hotel venue requiring high-level security and compliance standards.",
        contract_review_date: "2024-03-01",
        contract_start_date: "2021-01-15",
        contract_term: "3 Years",
        documents: [
          {
            date_added: "2021-01-10",
            date_modified: "2024-02-20",
            description: "Hotel security service contract",
            name: "King Street Hotel Security Agreement",
            private: true,
            tag: "contract",
            uuid: "hotel789-contract456-security123",
          },
        ],
        executing_parties: "David Thompson, General Manager; Great Man Security Services",
        licence_name: "Hotel Security Operations Licence",
        licence_number: "NSW-HOTEL-456789",
        logo: "https://www.example.com/greatman-hotel-logo.png",
        name: "King Street Grand Hotel",
        roles: [
          {
            credentials: [
              {
                data: '{"template_uuid":"789456123","type":"Security","name":"NSW Security Licence","description":"Security licence for hotel operations","timing_requirement":"Before commencing the Shift","source":"https://www.example.com/nsw-security.pdf","selected":true}',
                roles: [0],
                tags: [
                  "Security",
                  "Hotel",
                ],
                template: "789-456-123",
                type: "Security",
                uuid: "security789-456-123",
              },
            ],
            resource_rate_id: "h9f51429-df1h-6842-918e-449hg3gh7160",
            description: "Hotel security officer responsible for guest safety and property security.",
            item_code: "#HOTEL-001",
            name: "Hotel Security Officer",
            rates: [
              {
                item_code: "#HOTEL-STD",
                name: "Standard",
                value: 20,
              },
            ],
            uuid: "8gc17h96-8049-7894-e6if-5f296i99did9",
          },
        ],
        stations: [
          {
            name: "Main Hotel Lobby",
          },
          {
            name: "Executive Floor Access",
          },
        ],
        type: "Hotel",
        uuid: "9hd18i07-9150-8905-f7jg-6g307j00eje0",
        sign_on_distance: 120,
        resource_rates: [
          {
            description: "Hourly rates for hotel security personnel.",
            name: "Hotel Security Service Rates",
            rates: [
              {
                item_code: "HOTEL001",
                name: "Standard",
                value: 20,
              },
              {
                item_code: "HOTEL002",
                name: "Premium",
                value: 38,
              },
              {
                item_code: "HOTEL003",
                name: "Executive",
                value: 50,
              },
            ],
            uuid: "h9f51429-df1h-6842-918e-449hg3gh7160",
          },
        ],
      },
    }
  ];
}
